var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 27,
    viewBox: "0 0 35 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5576 2.62332H25.2285V1.74184C25.2285 0.78201 24.445 -0.00152588 23.4851 -0.00152588H12.0455C11.0857 -0.00152588 10.3022 0.78201 10.3022 1.74184V2.64291H5.95353C3.17197 2.62332 0.899719 4.89557 0.899719 7.67713V21.8787C0.899719 24.6799 3.17197 26.9325 5.95353 26.9325H29.538C32.3391 26.9325 34.5918 24.6603 34.5918 21.8787V7.67713C34.6114 4.89557 32.3391 2.62332 29.5576 2.62332ZM6.22776 10.1453C5.24834 10.1453 4.46481 9.36173 4.46481 8.38231C4.46481 7.40289 5.24834 6.61935 6.22776 6.61935C7.20718 6.61935 7.99072 7.40289 7.99072 8.38231C7.97113 9.36173 7.1876 10.1453 6.22776 10.1453ZM17.7653 23.2695C13.0837 23.2695 9.28355 19.4693 9.28355 14.7877C9.28355 10.1061 13.0837 6.30594 17.7653 6.30594C22.447 6.30594 26.2471 10.1061 26.2471 14.7877C26.2471 19.4693 22.4274 23.2695 17.7653 23.2695Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7654 21.6045C21.5302 21.6045 24.5821 18.5525 24.5821 14.7877C24.5821 11.0229 21.5302 7.97095 17.7654 7.97095C14.0006 7.97095 10.9486 11.0229 10.9486 14.7877C10.9486 18.5525 14.0006 21.6045 17.7654 21.6045Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.83b413bc8f9464f6196bc2d7b9f738be.svg";
export { ForwardRef as ReactComponent };